export const EVENTS_API_TAGS = ['SearchEvents', 'GetEventById'];
